import { render } from "./FactorValuesComparing.vue?vue&type=template&id=f9e7e970&scoped=true&ts=true"
import script from "./FactorValuesComparing.vue?vue&type=script&lang=ts"
export * from "./FactorValuesComparing.vue?vue&type=script&lang=ts"

import "./FactorValuesComparing.vue?vue&type=style&index=0&id=f9e7e970&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9e7e970"]])

export default __exports__